export const SUPPORTED_LANGUAGES = ['en', 'de'];

export const languageFromBrowser = () => {
  const defaultLanguage = 'de';
  const browserLanguage = (navigator.language || navigator.userLanguage).split(
    '-',
  )[0];

  return SUPPORTED_LANGUAGES.indexOf(browserLanguage) >= 0
    ? browserLanguage
    : defaultLanguage;
};

export const getLocaleId = () => {
  const { language } = window._hopsServerData;

  return language === 'de' ? 'de' : 'en';
};
